var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-top"},[_c('HomeHeader')],1),_c('div',{staticClass:"home-input"},[_c('HomeSearch')],1),_c('div',{staticClass:"home-content"},[_c('HomeContent')],1),_c('div',{staticClass:"home-footer"},[_c('HomeFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }